module.exports = __webpack_public_path__ + "56b94702e55aa3640045f9c1b44f4b92.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/phyto/one-day-herbs.jpg
 ** module id = 481
 ** module chunks = 0
 **/